import React from "react";

const AuthorPart = () => {
  return (
    <>
      <div className="w-full flex flex-col justify-center">
        {/* Author Image */}
        <img
          className="mx-auto rounded-full w-6/12 md:w-7/12"
          src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/about-image-300x300.jpg"
        />
        
        {/* Author Name */}
        <div className="text-center pt-4 text-lg text-black font-semibold uppercase">
          {/* Pushpendra Kulshreshtha */}
          amir vans
        </div>

        {/* About Author */}
        <div className="text-center py-4 px-6 md:px-0 text-sm text-gray-500">
          Nisi elit exercitation qui tempor voluptate veniam ut sint amet.
          Cillum voluptate veniam sint deserunt sit et anim non. Reprehenderit
          aliquip dolor sit sit. Eiusmod cupidatat consectetur velit proident.
        </div>
      </div>
    </>
  );
};

export default AuthorPart;
